import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import './styles/globals.css';
import App from './app/App';
import { queryClient } from '@/lib/queryClient';
import { createIDBPersister } from '@/lib/persister';
import { getActivePropertyId } from '@/lib/auth';
import { registerSW } from 'virtual:pwa-register';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element missing');

// Buster ties the persisted query cache to the active property —
// switching property invalidates by mismatching the storage key, so
// the new property never inherits stale data from the old one.
const buster = (getActivePropertyId() ?? 'anonymous').slice(0, 24);
const persister = createIDBPersister(buster);

// Register the PWA service worker. `autoUpdate` mode silently picks
// up new deploys on the next nav. We also poll once an hour as a
// belt-and-suspenders for very long-lived sessions.
registerSW({ immediate: true });

createRoot(rootEl).render(
  <StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister, maxAge: 24 * 60 * 60 * 1000, buster }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistQueryClientProvider>
  </StrictMode>,
);
